// sort two-part ID strings like '5::13'
export const hardwareIdSort = (a: string, b: string): number => {
  //extract all the parts and convert to numbers
  const [a1, a2, b1, b2] = [...a.split('::'), ...b.split('::')].map(Number)
  return a1 - b1 || a2 - b2 // if the first part is a tie (0) then compare the second part.
}
